export default function updateYmCounter(referrer, destUrl) {
	try {
		console.info('[ym] update');
		// eslint-disable-next-line no-undef
		ym(7766470, 'hit', destUrl, { params: { referer: referrer } });
	} catch (error) {
		console.error('[ym] not update', error);
	}
}
